export function joinPathClean(...args) {
    return args.map(p => p.replace(/^[\/\\]/,"").replace(/[\/\\]$/,"")).filter(p => p != "").join("/").replace(/\.\.[\/\\]/g, "");
}
